// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"0bfee779","151":"de8afc15","278":"4f024c37","359":"9c909cf1","680":"dcd5200e","896":"04e38aa1"}[chunkId] + ".chunk.js";
};